import { styled } from '@/stitches/index.js';

export const StyledFormFieldError = styled('div', {
  color: '$uiErrorRegular',
  fontSize: '$12',
  marginTop: '$4',
  paddingLeft: '$16',
  paddingRight: '$16',
});
